// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialModeOfPayState,
    ModeOfPaySchema,
    ModeOfPayFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const ModeOfPay = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [mode_of_pay, setModeOfPay] = useState(InitialModeOfPayState);

    const getModeOfPay = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.MODE_OF_PAYES + `/${id}`);
        const data = await response.json();
        setModeOfPay(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewModeOfPay = values.id === undefined;
        const url = isNewModeOfPay ? EntityConstants.MODE_OF_PAYES : EntityConstants.MODE_OF_PAYES + `/${values.id}`;
        const method = isNewModeOfPay ? post : put;
        const response = await method(url, { mode_of_pay: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewModeOfPay ? MessageContants.MODE_OF_PAY_CREATED : MessageContants.MODE_OF_PAY_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        if (id !== undefined) {
            getModeOfPay(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={mode_of_pay}
            validationSchema={ModeOfPaySchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {ModeOfPayFormFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.MODE_OF_PAY_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.MODE_OF_PAY_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>}
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

ModeOfPay.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default ModeOfPay;
